export default "__VITE_ASSET__Dfa_WR_n__"